import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';

const BasicModal = (props) => {
    const [varify, setVarify] = useState(false);

    const removeToggle = () => {
        setVarify(false);
    };

    const handleAccept = () => {
        // Your logic for accepting
        props.onRegistrationHandler();
        props.handleClose();
        removeToggle();
    };

    const handleClose = () => {
        props.handleClose();
        removeToggle();
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        height: '12rem',
        borderRadius: '15px',
        width: '22rem',
        padding: '2rem',
        color:'black'
    };

    return (
        <Modal open={props.open} onClose={handleClose}>
            <Box sx={modalStyle}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ marginBottom: '1rem' }}>
                        <input
                            type="checkbox"
                            id="terms"
                            name="terms"
                            size={50}
                            className=' mr-2'
                            onChange={(e) => setVarify(!varify)}
                        />
                        <label htmlFor='terms' style={{ fontSize: 'large' }}>
                            I confirm that I am 18 years of age or older.
                        </label>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid' }}>
                        {varify ? (
                            <>
                                <Button
                                    style={{ marginLeft: '20px' }}
                                    variant="contained"
                                    color="warning"
                                    onClick={handleAccept}
                                >
                                    Accept
                                </Button>
                                <Button
                                    style={{ marginLeft: '20px' }}
                                    variant="contained"
                                    color="error"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button variant="contained" disabled>
                                    Accept
                                </Button>
                                <Button
                                    style={{ marginLeft: '20px' }}
                                    variant="contained"
                                    color="error"
                                    onClick={handleClose}
                                >
                                    Cancel2
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default BasicModal;
